import { loginThunk } from './auth/login.slice';
import { postPersonalInformationThunk } from './personalInformation/postPersonalInformation.slice';
import { getSummaryThunk } from './summary/summary.slice';

const rootThunkData: any = [loginThunk, getSummaryThunk, postPersonalInformationThunk];

const rootThunkHandler = (data: any[]) => {
    const newJ = {
        data: {}
    };

    data.map((e) => {
        newJ.data = {
            ...newJ.data,
            [e.pending as string]: (state: { isLoading: boolean }) => {
                state.isLoading = true;
            },
            [e.fulfilled as string]: (state: { isLoading: boolean }) => {
                state.isLoading = false;
            },
            [e.rejected as string]: (state: { isLoading: boolean }) => {
                state.isLoading = false;
            }
        };
    });

    return newJ.data;
};

export const rootThunk = rootThunkHandler(rootThunkData);
